import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { useEmbedStore } from '@/stores/embedStore'
import { isEmbedded } from '@/lib/embed'
import EmbedNotice from '@/components/EmbedNotice'

interface AuthGuardProps {
  children: ReactNode
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const embedStatus = useEmbedStore((s) => s.status)
  const location = useLocation()

  // Embedded: render only once the parent's handshake (session + CSS) has landed,
  // so partner-hidden parts never flash. Never redirect a frame to the login form.
  if (isEmbedded()) {
    if (embedStatus === 'ready' && isAuthenticated) return <>{children}</>
    return <EmbedNotice state={embedStatus === 'connecting' ? 'connecting' : 'failed'} />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
